package app.bloomey.web.pages.admin

import androidx.compose.runtime.*
import app.bloomey.web.components.layouts.AdminPageLayout
import app.bloomey.web.components.sections.PageActionsBar
import app.bloomey.web.components.widgets.*
import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.offCanvas.LocalOffCanvasController
import app.bloomey.web.core.offCanvas.items.UserOffCanvas
import app.bloomey.web.modules.users.UsersContract
import app.bloomey.web.modules.users.UsersViewModel
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.datetime.Instant
import kotlinx.datetime.toJSDate
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Page
@Composable
fun UsersPage() {
    val offCanvasController = LocalOffCanvasController.current
    val coroutineScope = rememberCoroutineScope()
    val viewModel = remember { UsersViewModel(coroutineScope) }
    val uiState by viewModel.observeStates().collectAsState()
    val usersState = uiState.usersState
    val pageSize = 10
    val route = rememberPageContext().route
    val searchQuery = remember { mutableStateOf(route.queryParams["q"] ?: "") }

    val getPage = { page: Int ->
        viewModel.trySend(UsersContract.Inputs.GetUsers(page = page, size = pageSize, query = searchQuery.value))
    }
    LaunchedEffect(Unit) {
        getPage(1)
    }
    AdminPageLayout(pageTitle = "Users") {
        when (usersState) {
            is UiState.Error -> {
                SiteErrorView(text = usersState.errorMessage, modifier = Modifier.minHeight(80.vh)) {
                    getPage(uiState.page)
                }
            }

            UiState.Initial -> {}
            UiState.Loading -> {
                LoadingView(Modifier.minHeight(80.vh))
            }

            is UiState.Success -> {
                PageActionsBar(
                    modifier = Modifier.margin(top = 20.px, bottom = 30.px),
                    searchValue = searchQuery, onSearch = { getPage(1) })

                ShowingItems(modifier = Modifier.margin(bottom = 24.px), usersState.data.totalItems)
                SiteTable(
                    modifier = Modifier.fillMaxWidth().margin(bottom = 30.px).maxHeight(60.vh),
                    headers = listOf(
                        "Id",
                        "First Name",
                        "Last Name",
                        "Email",
                        "Created At"
                    ),
                    items = usersState.data.items,
                    itemModifier = { user ->
                        Modifier.onClick {
                            offCanvasController.push(UserOffCanvas(user.id, user = user) {
                                getPage(1)
                            })
                        }
                    }) { user ->
                    listOf(
                        { SpanText(user.id) },
                        { SpanText(user.firstName) },
                        { SpanText(user.lastName) },
                        { SpanText(user.email) },
                        {
                            SpanText(
                                Instant.fromEpochMilliseconds(user.createdAt).toJSDate().toDateString()
                            )
                        },
                    )
                }

                PaginationController(
                    modifier = Modifier
                        .alignSelf(AlignSelf.SelfEnd),
                    pageCount = usersState.data.totalPages,
                    currentPage = usersState.data.page
                ) {
                    getPage(it)
                }
            }
        }
    }
}
